export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers =
    init.body instanceof FormData
      ? init.headers
      : {
          'Content-Type': 'application/json',
          ...init.headers
        };

  const response = await fetch(`/api${path}`, {
    ...init,
    headers,
    credentials: 'include'
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => ({ error: 'request_failed' }))) as { error?: unknown };
    throw new Error(typeof body.error === 'string' ? body.error : 'request_failed');
  }

  return response.json() as Promise<T>;
}
